import { matchPath } from "react-router";

import { OrgData } from "@shared/types";

import { getOrgSlug, slugifyNameForOrg } from "../getOrgSlug";

/**
 * @param path the path from which to get the org slug (should contain
 * `/org/{slug}`)
 * @param orgs the list from which to find the org (all user orgs)
 * @returns the org that matched to the path, or undefined if no org matched or the
 * path did not contain an org slug.
 */
export const findOrgFromPath = (
  path: string,
  orgs: OrgData[]
): OrgData | undefined => {
  const orgSlugFromPath = matchPath<{ orgName?: string }>(path, {
    path: "/orgs/:orgName",
  })?.params.orgName;

  if (orgSlugFromPath === undefined) {
    return undefined;
  }

  let org = orgs.find((org) => getOrgSlug(org) === orgSlugFromPath);

  if (org === undefined) {
    // this is for backwards compatibility
    // try the old way of creating the org slug, which slugifies the org name
    // instead of directly using the org slug
    org = orgs.find((org) => slugifyNameForOrg(org.name) === orgSlugFromPath);
  }

  return org;
};
